var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.entryLink.attributes.entry.attributes.attachment)?_c('div',{staticClass:"ml-2"},[_c('b-tooltip',{attrs:{"label":"Anhang","position":"is-bottom"}},[_c('b-icon',{attrs:{"icon":"attachment"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }